export default __webpack_public_path__ + "static/media/qemscan-color-legend.84135310.png";